import { EDocsPath } from '~/layouts/account/models'

export const DOCS_BASE_URL = 'https://docs.replify.ai'

export const getIsDocsPath = (
  pathname?: string | null,
): pathname is EDocsPath =>
  pathname != null && Object.values(EDocsPath).includes(pathname as EDocsPath)

export const docsUrlBuilder = (docsPath: EDocsPath): string => {
  return `${DOCS_BASE_URL}${docsPath === '' ? '' : docsPath}`
}
